const Tune = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.094 17v2h6.188v-2H3.094zm0-12v2h10.314V5H3.094zm10.314 16v-2h8.252v-2h-8.252v-2h-2.063v6h2.063zM7.22 9v2H3.094v2H7.22v2h2.062V9H7.22zm14.44 4v-2H11.345v2H21.66zM15.47 9h2.063V7h4.126V5h-4.126V3h-2.063v6z" />
    </svg>
  );
};
export default Tune;
